import {
  VOID3gxj6tk5isa35 as VOID,
  copyOfRange3alro60z4hhf8 as copyOfRange,
  protoOf180f3jzyo7rfj as protoOf,
  objectCreate1ve4bgxiu4x98 as objectCreate,
  toCharArray32huqyw9tt7kx as toCharArray,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  Unit_instance1fbcbse1fwigr as Unit_instance,
  contentEquals1cdp6c846cfdi as contentEquals,
  contentHashCode25jw6rgkgywwr as contentHashCode,
  IndexOutOfBoundsException_init_$Create$2w5dv25cjssuw as IndexOutOfBoundsException_init_$Create$,
  _UByte___init__impl__g9hnc43ude1dscg1q30 as _UByte___init__impl__g9hnc4,
  _UByte___get_data__impl__jof9qr2p2xx2i2jvnz8 as _UByte___get_data__impl__jof9qr,
  compareTo3ankvs086tmwq as compareTo,
  StringBuilder_init_$Create$2ujvu6cqvzuyn as StringBuilder_init_$Create$,
  _Char___init__impl__6a9atx2js6krycynjoo as _Char___init__impl__6a9atx,
  Comparable198qfk8pnblz0 as Comparable,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  decodeToString1x4faah2liw2p as decodeToString,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
} from './kotlin-kotlin-stdlib.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
initMetadataForCompanion(Companion);
initMetadataForClass(ByteString, 'ByteString', VOID, VOID, [Comparable]);
initMetadataForObject(UnsafeByteStringOperations, 'UnsafeByteStringOperations');
//endregion
function ByteString_init_$Init$(data, startIndex, endIndex, $this) {
  startIndex = startIndex === VOID ? 0 : startIndex;
  endIndex = endIndex === VOID ? data.length : endIndex;
  ByteString.call($this, copyOfRange(data, startIndex, endIndex), null);
  return $this;
}
function ByteString_init_$Create$(data, startIndex, endIndex) {
  return ByteString_init_$Init$(data, startIndex, endIndex, objectCreate(protoOf(ByteString)));
}
function Companion() {
  Companion_instance = this;
  this.i1t_1 = new ByteString(new Int8Array(0), null);
  this.j1t_1 = toCharArray('0123456789abcdef');
}
protoOf(Companion).k1t = function (byteArray) {
  return new ByteString(byteArray, null);
};
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance == null)
    new Companion();
  return Companion_instance;
}
function ByteString(data, dummy) {
  Companion_getInstance();
  this.l1t_1 = data;
  this.m1t_1 = 0;
}
protoOf(ByteString).o = function () {
  return this.l1t_1.length;
};
protoOf(ByteString).equals = function (other) {
  if (this === other)
    return true;
  if (other == null || !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
    return false;
  if (!(other instanceof ByteString))
    THROW_CCE();
  if (!(other.l1t_1.length === this.l1t_1.length))
    return false;
  if (!(other.m1t_1 === 0) && !(this.m1t_1 === 0) && !(other.m1t_1 === this.m1t_1))
    return false;
  return contentEquals(this.l1t_1, other.l1t_1);
};
protoOf(ByteString).hashCode = function () {
  var hc = this.m1t_1;
  if (hc === 0) {
    hc = contentHashCode(this.l1t_1);
    this.m1t_1 = hc;
  }
  return hc;
};
protoOf(ByteString).p = function (index) {
  if (index < 0 || index >= this.o())
    throw IndexOutOfBoundsException_init_$Create$('index (' + index + ') is out of byte string bounds: [0..' + this.o() + ')');
  return this.l1t_1[index];
};
protoOf(ByteString).v1k = function (startIndex, endIndex) {
  var tmp;
  if (startIndex === endIndex) {
    tmp = Companion_getInstance().i1t_1;
  } else {
    tmp = ByteString_init_$Create$(this.l1t_1, startIndex, endIndex);
  }
  return tmp;
};
protoOf(ByteString).n1t = function (startIndex, endIndex, $super) {
  endIndex = endIndex === VOID ? this.o() : endIndex;
  return $super === VOID ? this.v1k(startIndex, endIndex) : $super.v1k.call(this, startIndex, endIndex);
};
protoOf(ByteString).o1t = function (other) {
  if (other === this)
    return 0;
  var localData = this.l1t_1;
  var otherData = other.l1t_1;
  var inductionVariable = 0;
  var tmp0 = this.o();
  // Inline function 'kotlin.math.min' call
  var b = other.o();
  var last = Math.min(tmp0, b);
  if (inductionVariable < last)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'kotlin.toUByte' call
      var this_0 = localData[i];
      var tmp0_0 = _UByte___init__impl__g9hnc4(this_0);
      // Inline function 'kotlin.toUByte' call
      var this_1 = otherData[i];
      // Inline function 'kotlin.UByte.compareTo' call
      var other_0 = _UByte___init__impl__g9hnc4(this_1);
      // Inline function 'kotlin.UByte.toInt' call
      var tmp = _UByte___get_data__impl__jof9qr(tmp0_0) & 255;
      // Inline function 'kotlin.UByte.toInt' call
      var tmp$ret$4 = _UByte___get_data__impl__jof9qr(other_0) & 255;
      var cmp = compareTo(tmp, tmp$ret$4);
      if (!(cmp === 0))
        return cmp;
    }
     while (inductionVariable < last);
  return compareTo(this.o(), other.o());
};
protoOf(ByteString).d = function (other) {
  return this.o1t(other instanceof ByteString ? other : THROW_CCE());
};
protoOf(ByteString).toString = function () {
  if (isEmpty(this)) {
    return 'ByteString(size=0)';
  }
  var sizeStr = this.o().toString();
  var len = (22 + sizeStr.length | 0) + imul(this.o(), 2) | 0;
  // Inline function 'kotlin.with' call
  var $this$with = StringBuilder_init_$Create$(len);
  $this$with.k7('ByteString(size=');
  $this$with.k7(sizeStr);
  $this$with.k7(' hex=');
  var localData = this.l1t_1;
  var inductionVariable = 0;
  var last = this.o();
  if (inductionVariable < last)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var b = localData[i];
      $this$with.l7(Companion_getInstance().j1t_1[(b >>> 4 | 0) & 15]);
      $this$with.l7(Companion_getInstance().j1t_1[b & 15]);
    }
     while (inductionVariable < last);
  return $this$with.l7(_Char___init__impl__6a9atx(41)).toString();
};
protoOf(ByteString).p1t = function () {
  return this.l1t_1;
};
function ByteString_0(bytes) {
  var tmp;
  // Inline function 'kotlin.collections.isEmpty' call
  if (bytes.length === 0) {
    tmp = Companion_getInstance().i1t_1;
  } else {
    tmp = Companion_getInstance().k1t(bytes);
  }
  return tmp;
}
function decodeToString_0(_this__u8e3s4) {
  return decodeToString(_this__u8e3s4.p1t());
}
function isEmpty(_this__u8e3s4) {
  return _this__u8e3s4.o() === 0;
}
function UnsafeByteStringOperations() {
}
protoOf(UnsafeByteStringOperations).q1t = function (array) {
  return Companion_getInstance().k1t(array);
};
var UnsafeByteStringOperations_instance;
function UnsafeByteStringOperations_getInstance() {
  return UnsafeByteStringOperations_instance;
}
//region block: init
UnsafeByteStringOperations_instance = new UnsafeByteStringOperations();
//endregion
//region block: exports
export {
  ByteString_init_$Create$ as ByteString_init_$Create$1zmsyrjuj9mwj,
  UnsafeByteStringOperations_instance as UnsafeByteStringOperations_instance24iw7lp31iicx,
  ByteString_0 as ByteString3c9fk8lsh3lvs,
  decodeToString_0 as decodeToString2ede220pr5xir,
};
//endregion

//# sourceMappingURL=kotlinx-io-kotlinx-io-bytestring.mjs.map
